import { get } from 'lodash';
import { createSelector } from 'reselect';
import moment from 'moment';

import { MonthEnum } from 'Common/Constants/Enumeration/MonthEnum';

const root = (state) => get(state, 'CommonState.controlInfo');

export const getControlInfoData = (state) => get(root(state), 'data');

export const getZonesId = (state) => get(getControlInfoData(state), 'ZonesId');

export const fiscalYear = (state) =>
  get(getControlInfoData(state), 'FiscalYear', new Date().getFullYear() + 1);
export const getFiscalYear = fiscalYear;

export const actualDT = (state) => get(getControlInfoData(state), 'ActualDT');
export const getActualDT = actualDT;

export const getFetching = (state) => get(root(state), 'fetching', false);

export const getReprocessTransactions = (state) =>
  get(getControlInfoData(state), 'ReprocessTransactions');

export const getFiscalYearStart = createSelector(
  getFiscalYear,
  getActualDT,
  (fiscalYear, actualDT) => {
    const start = moment()
      .year(fiscalYear - 1)
      .month(MonthEnum.July)
      .startOf('month');

    const actualDTMoment = moment(actualDT);

    /** If ActualDT is before then use ActualDT as the start of the fiscal year */
    return actualDTMoment.isBefore(start)
      ? actualDTMoment.toDate()
      : start.toDate();
  }
);

export const getFiscalYearEnd = createSelector(getFiscalYear, (fiscalYear) => {
  const end = moment().year(fiscalYear).month(MonthEnum.June).endOf('month');

  return end.toDate();
});

export const getShouldFetchControlInfo = createSelector(
  getControlInfoData,
  (controlInfoData) => !Object.keys(controlInfoData).length
);



// WEBPACK FOOTER //
// ./src/state/controlInfo/selectors.js